export interface NewsItem {
  id: string;
  title: string;
  date: string;
  category: string;
  summary: string;
  image: string;
  content: string[];
}

export const newsCategories = ["全部", "行业动态", "影视资讯", "热剧追踪", "综艺前瞻", "票房观察"];

export const newsList: NewsItem[] = [
  {
    id: "n1",
    title: "年度科幻巨制《星际孤航》口碑爆棚，观众直呼“太空史诗”",
    date: "2026-10-12",
    category: "影视资讯",
    summary: "《星际孤航》上线后迅速登上热榜，凭借震撼的视觉呈现与扎实的剧作收获大量好评。",
    image: "https://readdy.ai/api/search-image?query=cinematic%20space%20scene%20with%20astronaut%20before%20a%20ringed%20planet%2C%20deep%20nebula%20and%20warm%20orange%20glow%2C%20editorial%20news%20image%2C%20high%20detail%2C%20wide%20composition&width=1200&height=675&seq=news-img-01&orientation=landscape",
    content: [
      "由陈牧执导的年度科幻电影《星际孤航》正式上线后引发广泛讨论。影片讲述了一名宇航员在深空孤立无援的情况下寻找归途的故事，以冷峻的太空视觉与细腻的情感刻画征服了观众。",
      "不少观众表示，影片在宏大设定之外，真正打动人的是对“孤独”与“信念”的刻画。片中数段无对白的太空长镜头，被认为是近年科幻作品中极具冲击力的表达。",
      "业内评论认为，《星际孤航》在视觉特效与叙事节奏上的平衡处理，为国产科幻题材提供了新的思路。影片目前仍保持较高热度，相关话题持续登上讨论榜。",
      "片方透露，后续将推出幕后制作特辑，进一步揭秘影片中太空场景的构建过程与拍摄细节。",
    ],
  },
  {
    id: "n2",
    title: "悬疑剧《迷雾都市》第二季开更，剧情走向引发全网猜测",
    date: "2026-10-10",
    category: "热剧追踪",
    summary: "《迷雾都市》第二季正式回归，开篇即抛出新的谜团，观众讨论热度居高不下。",
    image: "https://readdy.ai/api/search-image?query=rainy%20city%20at%20night%20with%20neon%20signs%20and%20wet%20streets%2C%20moody%20teal%20and%20amber%2C%20editorial%20news%20image%2C%20high%20detail%2C%20wide%20composition&width=1200&height=675&seq=news-img-02&orientation=landscape",
    content: [
      "备受期待的悬疑剧《迷雾都市》第二季正式开播，首播两集便抛出了全新的案件线索，延续了第一季紧凑克制的叙事风格。",
      "新一季在保留原有主角阵容的基础上，引入了多条并行线索，案件之间的关联更加复杂。编剧团队表示，本季将更侧重人物内心的变化与选择的代价。",
      "开播当晚，相关话题迅速登上讨论榜，观众围绕剧情细节展开大量分析与推理，形成了“追剧解谜”的独特观剧体验。",
      "平台方表示，第二季将保持每周更新节奏，并在季中安排特别篇，为观众提供更多幕后内容。",
    ],
  },
  {
    id: "n3",
    title: "蘑菇音乐节夏日特辑收官，现场舞台获赞“今年最好听”",
    date: "2026-10-08",
    category: "综艺前瞻",
    summary: "《蘑菇音乐节》夏日特辑迎来收官，多组跨界的舞台合作成为最大亮点。",
    image: "https://readdy.ai/api/search-image?query=outdoor%20music%20festival%20stage%20at%20night%20with%20colorful%20lights%20and%20crowd%2C%20vibrant%20orange%20and%20magenta%20glow%2C%20editorial%20news%20image%2C%20high%20detail&width=1200&height=675&seq=news-img-03&orientation=landscape",
    content: [
      "《蘑菇音乐节》夏日特辑正式收官，本季节目汇集了多组风格各异的乐队与独立音乐人，用真诚的现场演出收获了口碑。",
      "节目最大的看点在于跨界合作舞台，不同风格的音乐人重新编排经典曲目，产生了令人惊喜的化学反应。多个舞台片段被观众反复回看。",
      "制作团队表示，节目希望为更多独立音乐人提供展示的舞台，也让观众感受到现场音乐的魅力。",
      "据悉，节目组已经在筹备下一季的录制，未来将进一步拓展舞台形式与曲风类型。",
    ],
  },
  {
    id: "n4",
    title: "东方奇幻剧《山海纪年》收官，美术设计被赞“每一帧都是壁纸”",
    date: "2026-10-05",
    category: "热剧追踪",
    summary: "《山海纪年》迎来收官，瑰丽的美术世界观与完整的故事线获得观众肯定。",
    image: "https://readdy.ai/api/search-image?query=mythical%20mountains%20above%20a%20misty%20sea%20with%20celestial%20glow%2C%20jade%20green%20and%20gold%20tones%2C%20editorial%20news%20image%2C%20high%20detail%2C%20wide%20composition&width=1200&height=675&seq=news-img-04&orientation=landscape",
    content: [
      "东方奇幻剧《山海纪年》正式收官，剧集以宏大的世界观和考究的美术设计，为观众构建了一个瑰丽的奇幻世界。",
      "从山海异兽到古城建筑，剧中的视觉呈现被观众评价为“每一帧都是壁纸”。美术团队透露，大量场景参考了古籍中的描述并进行了现代化转译。",
      "除了视觉，剧集在人物成长线与群像塑造上也获得了肯定。多条支线在收官阶段完成收束，情感表达克制而有力。",
      "制作方表示，未来将推出世界观设定集，进一步补全剧中的细节设定。",
    ],
  },
  {
    id: "n5",
    title: "行业观察：2026 年影视内容竞争加剧，精品化成为共识",
    date: "2026-10-02",
    category: "行业动态",
    summary: "随着观众审美提升，影视内容的精品化与差异化成为行业共同关注的方向。",
    image: "https://readdy.ai/api/search-image?query=modern%20cinema%20hall%20interior%20with%20warm%20lights%20and%20red%20seats%2C%20cinematic%20editorial%20news%20image%2C%20high%20detail&width=1200&height=675&seq=news-img-05&orientation=landscape",
    content: [
      "进入 2026 年，影视内容市场的竞争进一步加剧。观众的审美与选择更加成熟，单纯依赖流量与噱头的作品越来越难以获得持续关注。",
      "业内普遍认为，精品化与差异化将成为下一阶段的核心命题。扎实的剧本、用心的制作与清晰的价值表达，成为作品能否突围的关键。",
      "与此同时，题材的多元化趋势也更加明显，悬疑、科幻、历史、现实题材均有佳作涌现，为观众提供了更丰富的选择。",
      "分析人士指出，内容方需要更加重视用户口碑的长期价值，用持续稳定的产出建立品牌信任。",
    ],
  },
  {
    id: "n6",
    title: "《荒野信标》北美口碑走高，冒险题材再度受到关注",
    date: "2026-09-28",
    category: "影视资讯",
    summary: "《荒野信标》凭借真实的自然景观与情感力量，在冒险题材中脱颖而出。",
    image: "https://readdy.ai/api/search-image?query=sweeping%20mountain%20wilderness%20at%20dawn%20with%20a%20lone%20traveler%20and%20beacon%2C%20warm%20sunrise%20and%20cool%20shadow%2C%20editorial%20news%20image%2C%20high%20detail&width=1200&height=675&seq=news-img-06&orientation=landscape",
    content: [
      "冒险电影《荒野信标》上线后在北美市场收获良好口碑，影片以真实取景的自然景观与克制的情感表达获得关注。",
      "为了呈现荒野的真实质感，剧组在多个高海拔地区进行了长时间实景拍摄。导演表示，希望观众能感受到人在自然面前的渺小与坚韧。",
      "影评人认为，影片在冒险类型框架内做出了情感深度上的突破，主角的孤独感与坚持成为影片最动人的部分。",
      "随着口碑发酵，冒险题材再次受到市场关注，多部同类型项目陆续进入筹备阶段。",
    ],
  },
  {
    id: "n7",
    title: "旅行综艺《环游地球80天》回归，用真实旅程打动观众",
    date: "2026-09-24",
    category: "综艺前瞻",
    summary: "《环游地球80天》新一季回归，以真实旅程与自然互动延续节目特色。",
    image: "https://readdy.ai/api/search-image?query=scenic%20coastal%20town%20with%20mountains%20and%20sunny%20sky%2C%20sweeping%20travel%20landscape%2C%20editorial%20news%20image%2C%20high%20detail%2C%20wide%20composition&width=1200&height=675&seq=news-img-07&orientation=landscape",
    content: [
      "旅行综艺《环游地球80天》新一季正式回归，节目延续了“真实旅程、自然互动”的特色，减少刻意安排的桥段。",
      "嘉宾们在有限预算下自行规划路线、解决突发状况，旅途中的意外与相遇成为节目最大的看点。",
      "制作团队表示，节目希望呈现旅行最真实的一面，既有惊喜也有狼狈，而这些恰恰是最动人的部分。",
      "新一季在拍摄手法上进行了升级，大量使用自然光与长镜头，营造出更强的沉浸感。",
    ],
  },
  {
    id: "n8",
    title: "票房观察：暑期档表现稳健，观众更看重内容质量",
    date: "2026-09-20",
    category: "票房观察",
    summary: "暑期档整体表现稳健，多部口碑佳作实现长线放映，内容质量成为关键变量。",
    image: "https://readdy.ai/api/search-image?query=crowded%20cinema%20lobby%20with%20warm%20lights%20and%20movie%20posters%2C%20editorial%20news%20image%2C%20warm%20and%20neutral%20tones%2C%20high%20detail&width=1200&height=675&seq=news-img-08&orientation=landscape",
    content: [
      "暑期档整体票房表现稳健，虽然没有出现极端爆款，但多部作品凭借口碑实现了长线放映。",
      "数据显示，观众在选择影片时更加依赖真实评价，首周口碑对后续票房走势的影响愈发明显。",
      "分析认为，内容质量正在成为票房表现的关键变量。扎实的故事与真诚的表达，比短期营销更能带来持续的观众增长。",
      "展望后续档期，多部备受期待的作品已经定档，市场有望保持活跃。",
    ],
  },
  {
    id: "n9",
    title: "古装剧《江户物语》出海，东方美学引发海外讨论",
    date: "2026-09-16",
    category: "行业动态",
    summary: "《江户物语》在海外平台上线后，凭借东方美学与细腻叙事获得关注。",
    image: "https://readdy.ai/api/search-image?query=edo%20era%20town%20panorama%20with%20wooden%20buildings%20and%20lanterns%20at%20dusk%2C%20warm%20earthy%20tones%2C%20editorial%20news%20image%2C%20high%20detail&width=1200&height=675&seq=news-img-09&orientation=landscape",
    content: [
      "古装剧《江户物语》近日在海外平台上线，凭借考究的时代细节与细腻的日常叙事获得了海外观众的关注。",
      "剧中呈现的市井生活、手工艺与建筑美学，成为海外观众讨论的焦点。有评论称，剧集以“小人物、大时代”的视角展现了东方叙事的独特魅力。",
      "制作方表示，希望通过作品让更多人了解东方文化的细节之美，也为后续的海外发行积累经验。",
      "业内认为，优质古装内容的出海，为文化传播提供了新的路径。",
    ],
  },
];